module.exports = __webpack_public_path__ + "static/img/product_04.e7ef2a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_04.jpg
// module id = yLzM
// module chunks = 2